export default __webpack_public_path__ + "static/media/bcs.b0399669.png";